import { TextareaAutosize, useTheme } from "@mui/material";
import Typography from "../typography";

export interface TextAreaInputProps {
  minRows?: number;
  maxRows?: number;
  placeHolder?: string;
  value?: string;
  ariaLabel?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  error?: string;
  style?: React.CSSProperties;
  textAlign?: "left" | "center" | "right";
}

const TextArea: React.FC<TextAreaInputProps> = ({
  minRows = 3,
  maxRows = 3,
  placeHolder = "",
  value,
  ariaLabel = "maximum height",
  onChange,
  error,
  isDisabled = false,
  isRequired = false,
  textAlign = "left",
  style = {},
}) => {
  const theme = useTheme();

  return (
    <div style={style}>
      <TextareaAutosize
        aria-label={ariaLabel}
        minRows={minRows}
        maxRows={maxRows}
        style={{
          textAlign: textAlign,
          width: "98%",
          fontSize: 16,
        }}
        placeholder={placeHolder}
        value={value}
        disabled={isDisabled}
        required={isRequired}
        onChange={onChange}
      />

      {error && (
        <Typography
          color="error"
          variant="caption"
          style={{
            fontWeight: theme.typography.fontWeightLight,
            paddingLeft: theme.spacing(1),
            display: "flex",
            marginTop: "-1px",
          }}
        >
          * {error}
        </Typography>
      )}
    </div>
  );
};

export default TextArea;
